// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsEngagementReportsCanvasesByTagsResult = arrayOf(
  objectOf({
    workflow_name: string,
    id: string,
    created: objectOf({
      time: number,
    }),
    steps: arrayOf(
      objectOf({
        messagingActions: arrayOf(
          objectOf({
            message_type: string,
          })
        ),
      })
    ),
    is_archived: boolean,
  })
);
